<template>
  <div id="live-how-to">
    <BottomBar />
    <img src="https://cdn.anyteach.cn/live/how-to-join/1.jpg" />

    <div class="loading" v-if="loading">
      正在努力获取您的课程信息
      <inline-loading />
    </div>
    <div v-else>
      <div class="top">
        <h1>如何进入直播间？</h1>
        <h2>
          选择您购买的课程
          <span>👇</span>
        </h2>
      </div>
      <div class="switcher">
        <div class="item" :class="{ active: tab == 0 }" @click="tab = 0">试听课</div>
        <div class="item" :class="{ active: tab == 1 }" @click="tab = 1">13 周课</div>
      </div>
      <Demo
        class="animated fadeIn"
        v-if="tab == 0"
        :rooms="demo"
        :cs="cs"
        :is_orgs_user="is_orgs_user"
      />
      <Regular class="animated fadeIn" v-if="tab == 1" :rooms="regular" :cs="cs" />
    </div>
  </div>
</template>

<script>
import BottomBar from "../../public/footer"
import Demo from "./Demo"
import Regular from "./Regular"
export default {
  name: "HowTo",
  components: { BottomBar, Demo, Regular },
  data() {
    return {
      tab: 0,
      regular: [],
      demo: [],
      cs: null,
      is_orgs_user: false,
      loading: true,
      rooms: null,
    }
  },
  created() {
    this.getRooms()
    this.wxShare()
  },
  methods: {
    async getRooms() {
      const data = await this.$api.live.JOINED_ROOMS()
      this.demo = data.is_demo_rooms
      this.regular = data.standard_rooms
      this.cs = data.usercs
      this.is_orgs_user = Boolean(data.is_orgs_user)
      this.loading = false
    },
    async getLiveCode() {
      const { code, msg } = JSON.parse(await this.$api.live.CODE())
      if (code == 1000) {
        await Promise.all(
          msg.map(async val => {
            val.rooms = await this.getLiveRooms(val.code)
          }),
        )
        this.codes = msg
      }
    },
    async getLiveRooms(roomCode) {
      const { code, msg } = JSON.parse(await this.$api.live.ROOMSBYCODE(roomCode))
      if (code == 1000) {
        return msg
      }
      return []
    },
    wxShare() {
      const data = {
        title: "如何加入直播间？",
        desc: "查看 4 位房间码，加入最酷炫的 AnyTeach 直播课，13 周无限量的中外教全程陪伴。",
        link: window.homePageUrl + "/live/how-to",
        type: "custom",
      }
      bus.wxShareConfig(data)
    },
  },
}
</script>

<style scoped lang="scss">
@import "./style.scss";

// @import "../../../../static/css/public.scss";
#live-how-to {
  @include avenir();
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
  .animated {
    animation-delay: 0s !important;
    animation-duration: 2s !important;
  }

  .small-p {
    padding: 0 5%;
    text-align: center;
  }

  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
    color: rgba(53, 53, 53, 0.6);
    padding: 20px 0 0 0;
    i {
      width: 0.8rem;
      height: 0.8rem;
    }
  }

  .code-wrapper {
    border-radius: 5px;
    border: 1px solid #eee;
    margin: 0 5% 15px 5%;

    h1 {
      font-size: 1.25rem;
      padding: 0;
      margin: 0 0 5px 0;
      @include avenir-demi();
    }
    h2 {
      margin: 0;
      font-size: 1rem;
      line-height: 1.2;
      font-weight: 500;
    }
    h3 {
      font-size: 0.875rem;
      font-weight: 400;
    }

    .link {
      font-weight: 500;
    }
    .grey {
      color: $black;
      opacity: 0.6;
    }
    .code {
      text-align: center;
      padding: 20px 0;
    }
    .room-wrapper {
      border-top: 1px solid #eee;
      padding: 15px 3% 15px 0;
      width: 95%;
      margin-left: 5%;
      &:first-of-type {
        border-top: none;
      }
    }
    .room {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        text-align: left;
      }
    }
  }
}
</style>
